import {
  faCog,
  faFileSignature,
  faHome,
  faPlus,
  faUserFriends,
  faUsers,
  faLock,
  faCogs,
  faBook,
  faCreditCard,
  faUser,
  faChalkboardTeacher,
  faBoxes,
  faReceipt,
  faUserEdit,
  faBookOpen,
} from "@fortawesome/free-solid-svg-icons";

import ApplicationRoutes from "./ApplicationRoutes";

export const AllRoutes: ApplicationRoutes = {
  AUTH_LOGIN: {
    path: "/auth/login",
    exact: true,
    isPrivate: false,
    icon: faHome,
    name: "app.page.home.heading",
  },

  AUTH_LOGOUT: {
    path: "/auth/logout",
    exact: true,
    isPrivate: false,
    icon: faHome,
  },

  AUTH_RESET_PASSWORD: {
    path: "/auth/reset-password",
    exact: true,
    isPrivate: false,
    icon: faHome,
  },

  AUTH_SET_NEW_PASSWORD: {
    path: "/auth/reset-password/:token",
    isPrivate: false,
    icon: faHome,
  },

  AUTH_SSO_LOGIN: {
    path: "/user/login/sso-response",
    exact: true,
    isPrivate: false,
    icon: faHome,
  },

  ERROR_404: {
    path: "/error",
    exact: false,
    isPrivate: false,
    icon: faHome,
  },

  USER_SETTINGS: {
    path: "/admin/settings",
    isPrivate: true,
    icon: faCog,
    name: "Settings",
  },

  CUSTOMERS_LIST: {
    path: "/admin/customers/list",
    isPrivate: true,
    icon: faUserFriends,
    name: "app.page.customers.heading",
  },

  CUSTOMERS_ADD: {
    path: "/admin/customers/add",
    isPrivate: true,
    icon: faUserFriends,
  },

  CUSTOMERS_EDIT: {
    path: "/admin/customers/edit/:id",
    isPrivate: true,
    icon: faUserFriends,
  },

  DOCUMENTS_LIST: {
    path: "/admin/documents/list/:type",
    isPrivate: true,
    icon: faFileSignature,
    name: "app.page.documents.zuz.heading",
  },

  DOCUMENTS_LIST_ZUZ: {
    path: "/admin/documents/list/zuz",
    isPrivate: true,
    icon: faFileSignature,
    name: "app.page.documents.zuz.heading",
  },

  DOCUMENTS_LIST_CHECK: {
    path: "/admin/documents/list/check",
    isPrivate: true,
    icon: faFileSignature,
    name: "app.page.documents.check.heading",
  },

  DOCUMENT_VIEW: {
    path: "/admin/documents/:id",
    isPrivate: true,
    icon: faFileSignature,
  },

  DOCUMENT_EDIT_CHECK: {
    path: "/admin/documents/check/:id/edit",
    isPrivate: true,
    icon: faFileSignature,
  },

  DOCUMENT_EDIT_ZUZ: {
    path: "/admin/documents/zuz/:id/edit",
    isPrivate: true,
    icon: faFileSignature,
  },

  DOCUMENTS_ADD_ZUZ: {
    path: "/admin/documents/add/zuz",
    isPrivate: true,
    icon: faPlus,
  },

  DOCUMENTS_ADD_CHECK: {
    path: "/admin/documents/add/check",
    isPrivate: true,
    icon: faPlus,
  },

  DOCUMENT_ADD_ZUZ: {
    path: "/admin/documents/add/zuz",
    isPrivate: true,
    icon: faPlus,
  },

  DOCUMENT_ADD_LIST: {
    path: "/admin/documents/add/list",
    isPrivate: true,
    icon: faPlus,
  },

  USERS_LIST: {
    path: "/admin/users/list",
    isPrivate: true,
    icon: faUsers,
    name: "app.page.users.heading",
  },
  USER_DETAIL: {
    path: "/admin/users/:id",
    isPrivate: true,
    icon: faUser,
    name: "app.page.user.heading",
  },
  LECTURERS_LIST: {
    path: "/admin/lecturers/list",
    isPrivate: true,
    icon: faChalkboardTeacher,
    name: "app.page.lecturers.heading",
  },
  LECTURER_DETAIL: {
    path: "/admin/lecturers/:id",
    isPrivate: true,
    icon: faUserEdit,
    name: "app.page.lecturer.heading",
  },
  LECTURERS_ADD: {
    path: "/admin/lecturers/add",
    isPrivate: true,
    icon: faUserEdit,
    name: "app.page.lecturer.heading",
  },
  COURSES_LIST: {
    path: "/admin/courses/list",
    isPrivate: true,
    icon: faBookOpen,
    name: "app.page.courses.heading",
  },

  COURSE_DETAIL: {
    path: "/admin/courses/:id",
    isPrivate: true,
    icon: faBook,
    name: "app.page.courses.heading",
  },
  COURSES_ADD: {
    path: "/admin/courses/add",
    isPrivate: true,
    icon: faBook,
    name: "app.page.courses.heading",
  },
  LESSON_DETAIL: {
    path: "/admin/lessons/:id",
    isPrivate: true,
    icon: faBook,
    name: "app.page.lesson.heading",
  },
  PAYMENTS_LIST: {
    path: "/admin/payments/list",
    isPrivate: true,
    icon: faCreditCard,
    name: "app.page.payments.heading",
  },
  PAYMENT_DETAIL: {
    path: "/admin/payments/:id",
    isPrivate: true,
    icon: faCreditCard,
    name: "app.page.payments.heading",
  },
  IDENTIFICATION_LIST: {
    path: "/admin/identifications/list",
    isPrivate: true,
    icon: faLock,
    name: "app.page.identifications.heading",
  },
  PRODUCTS_LIST: {
    path: "/admin/products/list",
    isPrivate: true,
    icon: faBoxes,
    name: "app.page.products.heading",
  },
  SUBSCRIPTIONS_LIST: {
    path: "/admin/subscriptions/list",
    isPrivate: true,
    icon: faReceipt,
    name: "app.page.subscriptions.heading",
  },
  SUBSCRIPTION_PACKAGE_DETAIL: {
    path: "/admin/subscriptions/:id",
    isPrivate: true,
    icon: faReceipt,
  },
  IDENTIFICATION_CALLBACK: {
    path: "/identification/id-provider-callback",
    isPrivate: false,
    icon: faLock,
  },

  IDENTIFICATION_DETAIL: {
    path: "/admin/identification/:id",
    isPrivate: true,
    icon: faLock,
  },

  USERS_ADD: {
    path: "/admin/users/add",
    isPrivate: true,
    icon: faUsers,
  },

  USERS_EDIT: {
    path: "/admin/users/edit/:id",
    isPrivate: true,
    icon: faUsers,
  },

  SYSTEM_MANAGEMENT_VIEW: {
    path: "/admin/system/management",
    isPrivate: true,
    icon: faCogs,
    name: "app.page.systemManagement.heading",
  },

  DASHBOARD: {
    path: "/admin/dashboard",
    isPrivate: true,
    icon: faHome,
    name: "app.page.dashboard.heading",
  },
  ROOT: {
    path: "/",
    isPrivate: true,
    icon: faHome,
  },
};

export const useAllRoutesAsForRouter = () => {
  return Object.values(AllRoutes).map((item) => ({
    path: item.path,
  }));
};
